import React from 'react';
import { useWorkflows } from '../contexts/WorkflowContext';

const KeywordChips = ({ visible }) => {
  const { allKeywords, selectedKeywords, toggleKeyword } = useWorkflows();

  // 按维度分组关键词（这里需要从tags数据中重新构建）
  const dimensionColors = {
    'Product-related': '#e3f2fd',     // 浅蓝色
    'Structure-related': '#f3e5f5',   // 浅紫色  
    'Machine-related': '#e8f5e8'      // 浅绿色
  };

  // Convert Set to Array for rendering
  const keywordsArray = Array.from(allKeywords);

  return (
    <div 
      id="keywordChips" 
      style={{
        display: visible ? 'block' : 'none',
        opacity: visible ? '1' : '0',
        transition: 'opacity 0.3s ease-in-out',
        padding: '10px',
        backgroundColor: '#f0f0f0',
        borderRadius: '5px',
        marginTop: '5px'
      }}
    >
      {/* 按维度分组显示 */}
      {Object.entries(dimensionColors).map(([dimension, color]) => (
        <div key={dimension} style={{ marginBottom: '8px' }}>
          <div style={{ 
            fontSize: '11px', 
            fontWeight: 'bold', 
            marginBottom: '4px',
            color: '#666'
          }}>
            {dimension.replace('-related', '')}:
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {keywordsArray
              .filter(keyword => {
                // 这里需要根据keyword判断属于哪个维度
                // 简化版本：可以根据keyword内容判断
                if (dimension === 'Product-related') {
                  return ['Wood', 'Acrylic', 'Wire', 'Silicone', 'Foam', 'Paper', 'Clay', 'Bamboo', 'Copper', 'Plastic', 'Durability', 'Flexibility', 'Lightweight', 'Conductive', 'Precise', 'SVG Export', 'DIY', 'Epoxy Resin', 'Wool', 'White Glue', 'Wax', 'Yarn'].includes(keyword);
                } else if (dimension === 'Structure-related') {
                  return ['Easy to Assemble', 'Modularity', 'Mold', 'Casting', 'Replication', 'Rapid Prototyping', 'Electroplating', 'Unfolding', 'Assembly', 'Needle Felting', 'Precision', 'Removability', 'Reusability'].includes(keyword);
                } else { // Machine-related
                  return ['Laser Cutter', 'Wire Bender', '3D Printing', 'Hot Wire', 'Paper Craft', 'Sander', 'Knitting & Quilitry Tools', 'Clay Tools', 'Hot Wire Foam Cutter', 'Filt Tools'].includes(keyword);
                }
              })
              .map(keyword => (
                <span
                  key={keyword}
                   data-keyword={keyword}
                  className={`chip ${selectedKeywords.has(keyword) ? 'selected' : ''}`}
                  onClick={() => toggleKeyword(keyword)}
                  style={{
                    display: 'inline-block',
                    padding: '4px 8px',
                    backgroundColor: selectedKeywords.has(keyword) ? '#3288e6' : color,
                    color: selectedKeywords.has(keyword) ? 'white' : '#333',
                    borderRadius: '12px',
                    fontSize: '11px',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    border: `1px solid ${selectedKeywords.has(keyword) ? '#3288e6' : '#ddd'}`
                  }}
                >
                  {keyword}
                </span>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default KeywordChips;